(() => {
  const roots =
    document.querySelectorAll(
      '[data-lp-qualifier]:not([data-lp-qualifier-ready="true"])'
    );

  if (!roots.length) return;

  const reducedMotion =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

  const serviceAliases = {
    'new-store': 'new-store',
    'build': 'new-store',
    'shopify-development': 'new-store',

    'migration': 'migration',
    'move-to-shopify': 'migration',

    'shopify-redesign': 'redesign',
    'redesign': 'redesign',

    'custom-development': 'custom-development',
    'custom-dev': 'custom-development',

    'custom-feature': 'custom-feature',
    'feature': 'custom-feature',

    'store-improvement': 'store-improvement',
    'improvement': 'store-improvement',
    'conversion': 'store-improvement',
    'cro': 'store-improvement',
    'cro-growth': 'store-improvement',
    'improve-conversion': 'store-improvement',

    'store-rescue': 'store-rescue',
    'rescue': 'store-rescue',
    'fix': 'store-rescue',

    'not-sure': 'unsure',
    'unsure': 'unsure'
  };

  const services = [
    ['new-store', 'Build a new Shopify store'],
    ['migration', 'Move to Shopify'],
    ['redesign', 'Redesign my Shopify store'],
    ['store-rescue', 'Fix a Shopify store'],
    ['unsure', 'I’m not sure yet']
  ];

  const budgetsFull = [
    ['under-25k', 'Under ₹25K'],
    ['25k-50k', '₹25K–₹50K'],
    ['50k-75k', '₹50K–₹75K'],
    ['75k-1l', '₹75K–₹1L'],
    ['1l-2l', '₹1L–₹2L'],
    ['2l-plus', '₹2L+'],
    ['not-sure', 'Not sure yet']
  ];

  const budgetsNewStore = budgetsFull.filter(
    ([value]) => value !== 'not-sure'
  );

  const budgetsFeature = [
    ['under-25k', 'Under ₹25K'],
    ['25k-50k', '₹25K–₹50K'],
    ['50k-75k', '₹50K–₹75K'],
    ['75k-1l', '₹75K–₹1L'],
    ['not-sure', 'Not sure yet']
  ];

  const budgetsSmall = [
    ['under-25k', 'Under ₹25K'],
    ['25k-50k', '₹25K–₹50K'],
    ['not-sure', 'Not sure yet']
  ];

  const timelines = [
    ['asap', 'As soon as possible'],
    ['2-weeks', 'Within 2 weeks'],
    ['1-month', 'Within 1 month'],
    ['2-months', 'Within 2 months'],
    ['exploring', 'Just exploring']
  ];

  const fallbackCountries = [
    ['IN', 'India', '+91'],
    ['US', 'United States', '+1'],
    ['GB', 'United Kingdom', '+44'],
    ['AU', 'Australia', '+61'],
    ['AE', 'United Arab Emirates', '+971'],
    ['CA', 'Canada', '+1'],
    ['ZA', 'South Africa', '+27'],
    ['SG', 'Singapore', '+65'],
    ['NZ', 'New Zealand', '+64'],
    ['AF', 'Afghanistan', '+93'],
    ['AL', 'Albania', '+355'],
    ['DZ', 'Algeria', '+213'],
    ['AS', 'American Samoa', '+1684'],
    ['AO', 'Angola', '+244'],
    ['AI', 'Anguilla', '+1264'],
    ['AG', 'Antigua and Barbuda', '+1268'],
    ['AR', 'Argentina', '+54'],
    ['AM', 'Armenia', '+374'],
    ['AW', 'Aruba', '+297'],
    ['AT', 'Austria', '+43'],
    ['AZ', 'Azerbaijan', '+994'],
    ['BH', 'Bahrain', '+973'],
    ['BD', 'Bangladesh', '+880'],
    ['BB', 'Barbados', '+1246'],
    ['BY', 'Belarus', '+375'],
    ['BE', 'Belgium', '+32'],
    ['BZ', 'Belize', '+501'],
    ['BJ', 'Benin', '+229'],
    ['BM', 'Bermuda', '+1441'],
    ['BT', 'Bhutan', '+975'],
    ['BO', 'Bolivia', '+591'],
    ['BA', 'Bosnia and Herzegovina', '+387'],
    ['BW', 'Botswana', '+267'],
    ['BR', 'Brazil', '+55'],
    ['IO', 'British Indian Ocean Territory', '+246'],
    ['BN', 'Brunei', '+673'],
    ['BG', 'Bulgaria', '+359'],
    ['BF', 'Burkina Faso', '+226'],
    ['BI', 'Burundi', '+257'],
    ['KH', 'Cambodia', '+855'],
    ['CM', 'Cameroon', '+237'],
    ['CV', 'Cape Verde', '+238'],
    ['KY', 'Cayman Islands', '+1345'],
    ['CF', 'Central African Republic', '+236'],
    ['TD', 'Chad', '+235'],
    ['CL', 'Chile', '+56'],
    ['CN', 'China', '+86'],
    ['CX', 'Christmas Island', '+61'],
    ['CC', 'Cocos (Keeling) Islands', '+61'],
    ['CO', 'Colombia', '+57'],
    ['KM', 'Comoros', '+269'],
    ['CK', 'Cook Islands', '+682'],
    ['CR', 'Costa Rica', '+506'],
    ['HR', 'Croatia', '+385'],
    ['CU', 'Cuba', '+53'],
    ['CY', 'Cyprus', '+357'],
    ['CZ', 'Czechia', '+420'],
    ['CD', 'Democratic Republic of the Congo', '+243'],
    ['DK', 'Denmark', '+45'],
    ['DJ', 'Djibouti', '+253'],
    ['DM', 'Dominica', '+1767'],
    ['DO', 'Dominican Republic', '+1809'],
    ['TL', 'East Timor', '+670'],
    ['EC', 'Ecuador', '+593'],
    ['EG', 'Egypt', '+20'],
    ['SV', 'El Salvador', '+503'],
    ['GQ', 'Equatorial Guinea', '+240'],
    ['ER', 'Eritrea', '+291'],
    ['EE', 'Estonia', '+372'],
    ['ET', 'Ethiopia', '+251'],
    ['FK', 'Falkland Islands', '+500'],
    ['FO', 'Faroe Islands', '+298'],
    ['FM', 'Federated States of Micronesia', '+691'],
    ['FJ', 'Fiji', '+679'],
    ['FI', 'Finland', '+358'],
    ['FR', 'France', '+33'],
    ['GF', 'French Guiana', '+594'],
    ['PF', 'French Polynesia', '+689'],
    ['GA', 'Gabon', '+241'],
    ['GE', 'Georgia', '+995'],
    ['DE', 'Germany', '+49'],
    ['GH', 'Ghana', '+233'],
    ['GI', 'Gibraltar', '+350'],
    ['GR', 'Greece', '+30'],
    ['GL', 'Greenland', '+299'],
    ['GD', 'Grenada', '+1473'],
    ['GP', 'Guadeloupe', '+590'],
    ['GU', 'Guam', '+1671'],
    ['GT', 'Guatemala', '+502'],
    ['GG', 'Guernsey', '+44'],
    ['GN', 'Guinea', '+224'],
    ['GW', 'Guinea-Bissau', '+245'],
    ['GY', 'Guyana', '+592'],
    ['HT', 'Haiti', '+509'],
    ['HN', 'Honduras', '+504'],
    ['HK', 'Hong Kong', '+852'],
    ['HU', 'Hungary', '+36'],
    ['IS', 'Iceland', '+354'],
    ['ID', 'Indonesia', '+62'],
    ['IR', 'Iran', '+98'],
    ['IQ', 'Iraq', '+964'],
    ['IE', 'Ireland', '+353'],
    ['IM', 'Isle of Man', '+44'],
    ['IL', 'Israel', '+972'],
    ['IT', 'Italy', '+39'],
    ['CI', 'Ivory Coast', '+225'],
    ['JM', 'Jamaica', '+1876'],
    ['JP', 'Japan', '+81'],
    ['JE', 'Jersey', '+44'],
    ['JO', 'Jordan', '+962'],
    ['KZ', 'Kazakhstan', '+76'],
    ['KE', 'Kenya', '+254'],
    ['KI', 'Kiribati', '+686'],
    ['KW', 'Kuwait', '+965'],
    ['KG', 'Kyrgyzstan', '+996'],
    ['LA', 'Laos', '+856'],
    ['LV', 'Latvia', '+371'],
    ['LB', 'Lebanon', '+961'],
    ['LS', 'Lesotho', '+266'],
    ['LR', 'Liberia', '+231'],
    ['LY', 'Libya', '+218'],
    ['LI', 'Liechtenstein', '+423'],
    ['LT', 'Lithuania', '+370'],
    ['LU', 'Luxembourg', '+352'],
    ['MO', 'Macau', '+853'],
    ['MG', 'Madagascar', '+261'],
    ['MW', 'Malawi', '+265'],
    ['MY', 'Malaysia', '+60'],
    ['MV', 'Maldives', '+960'],
    ['ML', 'Mali', '+223'],
    ['MT', 'Malta', '+356'],
    ['MH', 'Marshall Islands', '+692'],
    ['MQ', 'Martinique', '+596'],
    ['MR', 'Mauritania', '+222'],
    ['MU', 'Mauritius', '+230'],
    ['YT', 'Mayotte', '+262'],
    ['MX', 'Mexico', '+52'],
    ['MD', 'Moldova', '+373'],
    ['MC', 'Monaco', '+377'],
    ['MN', 'Mongolia', '+976'],
    ['MS', 'Montserrat', '+1664'],
    ['MA', 'Morocco', '+212'],
    ['MZ', 'Mozambique', '+258'],
    ['NA', 'Namibia', '+264'],
    ['NR', 'Nauru', '+674'],
    ['NP', 'Nepal', '+977'],
    ['NL', 'Netherlands', '+31'],
    ['NC', 'New Caledonia', '+687'],
    ['NI', 'Nicaragua', '+505'],
    ['NE', 'Niger', '+227'],
    ['NG', 'Nigeria', '+234'],
    ['NU', 'Niue', '+683'],
    ['NF', 'Norfolk Island', '+672'],
    ['KP', 'North Korea', '+850'],
    ['MP', 'Northern Mariana Islands', '+1670'],
    ['NO', 'Norway', '+47'],
    ['OM', 'Oman', '+968'],
    ['PK', 'Pakistan', '+92'],
    ['PW', 'Palau', '+680'],
    ['PA', 'Panama', '+507'],
    ['PG', 'Papua New Guinea', '+675'],
    ['PY', 'Paraguay', '+595'],
    ['PE', 'Peru', '+51'],
    ['PH', 'Philippines', '+63'],
    ['PN', 'Pitcairn Islands', '+64'],
    ['PL', 'Poland', '+48'],
    ['PT', 'Portugal', '+351'],
    ['PR', 'Puerto Rico', '+1787'],
    ['QA', 'Qatar', '+974'],
    ['MK', 'Republic of Macedonia', '+389'],
    ['CG', 'Republic of the Congo', '+242'],
    ['RO', 'Romania', '+40'],
    ['RU', 'Russia', '+7'],
    ['RW', 'Rwanda', '+250'],
    ['RE', 'Réunion', '+262'],
    ['SH', 'Saint Helena', '+290'],
    ['KN', 'Saint Kitts and Nevis', '+1869'],
    ['LC', 'Saint Lucia', '+1758'],
    ['PM', 'Saint Pierre and Miquelon', '+508'],
    ['VC', 'Saint Vincent and the Grenadines', '+1784'],
    ['WS', 'Samoa', '+685'],
    ['SM', 'San Marino', '+378'],
    ['SA', 'Saudi Arabia', '+966'],
    ['SN', 'Senegal', '+221'],
    ['RS', 'Serbia', '+381'],
    ['SC', 'Seychelles', '+248'],
    ['SL', 'Sierra Leone', '+232'],
    ['SK', 'Slovakia', '+421'],
    ['SI', 'Slovenia', '+386'],
    ['SB', 'Solomon Islands', '+677'],
    ['SO', 'Somalia', '+252'],
    ['GS', 'South Georgia', '+500'],
    ['KR', 'South Korea', '+82'],
    ['SS', 'South Sudan', '+211'],
    ['ES', 'Spain', '+34'],
    ['LK', 'Sri Lanka', '+94'],
    ['SD', 'Sudan', '+249'],
    ['SR', 'Suriname', '+597'],
    ['SJ', 'Svalbard and Jan Mayen', '+4779'],
    ['SZ', 'Swaziland', '+268'],
    ['SE', 'Sweden', '+46'],
    ['CH', 'Switzerland', '+41'],
    ['SY', 'Syria', '+963'],
    ['ST', 'São Tomé and Príncipe', '+239'],
    ['TW', 'Taiwan', '+886'],
    ['TJ', 'Tajikistan', '+992'],
    ['TZ', 'Tanzania', '+255'],
    ['TH', 'Thailand', '+66'],
    ['BS', 'The Bahamas', '+1242'],
    ['GM', 'The Gambia', '+220'],
    ['TG', 'Togo', '+228'],
    ['TK', 'Tokelau', '+690'],
    ['TO', 'Tonga', '+676'],
    ['TT', 'Trinidad and Tobago', '+1868'],
    ['TN', 'Tunisia', '+216'],
    ['TM', 'Turkmenistan', '+993'],
    ['TV', 'Tuvalu', '+688'],
    ['TR', 'Türkiye', '+90'],
    ['UG', 'Uganda', '+256'],
    ['UA', 'Ukraine', '+380'],
    ['UY', 'Uruguay', '+598'],
    ['UZ', 'Uzbekistan', '+998'],
    ['VU', 'Vanuatu', '+678'],
    ['VE', 'Venezuela', '+58'],
    ['VN', 'Vietnam', '+84'],
    ['WF', 'Wallis and Futuna', '+681'],
    ['EH', 'Western Sahara', '+212'],
    ['YE', 'Yemen', '+967'],
    ['ZM', 'Zambia', '+260'],
    ['ZW', 'Zimbabwe', '+263'],
  ];

  const branchSteps = {
    'new-store': [
      {
        id: 'new_store_stage',
        type: 'choice',
        question: 'Where are you right now?',
        options: [
          ['starting-new', 'Starting a new brand'],
          ['brand-exists', 'Brand already exists'],
          ['selling-offline', 'Selling offline'],
          ['marketplaces-social', 'Selling on marketplaces/social'],
          ['planning', 'Still planning']
        ]
      },
      {
        id: 'brand_name',
        type: 'text',
        question:
          'What’s your brand or business name?',
        placeholder:
          'Brand / business name...',
        autocomplete:
          'organization'
      },
      {
        id: 'new_store_presence',
        type: 'choice',
        question: 'Do you already have something we can look at?',
        options: [
          ['website', 'Website'],
          ['instagram', 'Instagram'],
          ['marketplace', 'Marketplace store'],
          ['nothing', 'Nothing yet']
        ]
      },
      {
        id: 'new_store_url',
        type: 'text',
        kind: 'url',
        question: 'Share the link so we can get some context.',
        placeholder: 'Website, Instagram or store URL...',
        autocomplete: 'url'
      }
    ],

    migration: [
      {
        id: 'migration_platform',
        type: 'choice',
        question: 'What are you moving from?',
        options: [
          ['woocommerce', 'WooCommerce'],
          ['magento', 'Magento'],
          ['wix', 'Wix'],
          ['squarespace', 'Squarespace'],
          ['hubspot', 'Hubspot'],
          ['custom', 'Custom website'],
          ['other', 'Another platform']
        ]
      },
      {
        id: 'migration_url',
        type: 'text',
        kind: 'url',
        question: 'What’s your current website URL?',
        placeholder: 'Website URL...',
        autocomplete: 'url'
      },
      {
        id: 'migration_design',
        type: 'choice',
        question: 'What should happen to the current design?',
        options: [
          ['keep-similar', 'Keep it similar'],
          ['improve', 'Improve it during migration'],
          ['redesign', 'Complete redesign'],
          ['not-sure', 'Not sure yet']
        ]
      },
      {
        id: 'migration_orders',
        type: 'choice',
        question: 'Is the current store taking orders?',
        options: [
          ['regularly', 'Yes, regularly'],
          ['sometimes', 'Sometimes'],
          ['no', 'No'],
          ['not-sure', 'Not sure']
        ]
      }
    ],

    redesign: [
      {
        id: 'redesign_live',
        type: 'choice',
        question: 'Is your Shopify store live right now?',
        options: [
          ['yes', 'Yes, it’s live'],
          ['no', 'No, not live yet']
        ]
      },
      {
        id: 'redesign_reason',
        type: 'choice',
        question: 'What’s the main reason you want to redesign it?',
        options: [
          ['outdated', 'Store looks outdated'],
          ['hard-to-shop', 'Hard to shop'],
          ['brand-changed', 'Brand has changed'],
          ['low-conversion', 'Low conversion'],
          ['mobile', 'Mobile needs improvement'],
          ['multiple', 'More than one issue']
        ]
      },
      {
        id: 'redesign_scope',
        type: 'choice',
        question: 'Which part do you want to redesign?',
        options: [
          ['full-store', 'Full store'],
          ['homepage', 'Homepage'],
          ['product-pages', 'Product pages'],
          ['collection-pages', 'Collection pages'],
          ['cart', 'Cart'],
          ['mobile', 'Mobile experience'],
          ['key-pages', 'A few key pages'],
          ['not-sure', 'Not sure yet']
        ]
      },
      {
        id: 'redesign_url',
        type: 'text',
        kind: 'url',
        question: 'Please share your store link so we can understand the current setup.',
        placeholder: 'Store URL...',
        autocomplete: 'url'
      }
    ],

    'custom-development': [
      {
        id: 'development_type',
        type: 'choice',
        question: 'What kind of development do you need?',
        options: [
          ['custom-theme', 'Custom theme development'],
          ['figma-shopify', 'Figma to Shopify'],
          ['custom-sections', 'Custom sections'],
          ['custom-pages', 'Custom pages/templates'],
          ['frontend', 'Frontend development'],
          ['functions', 'Shopify Functions'],
          ['app-integration', 'App integration'],
          ['multiple', 'Multiple things'],
          ['not-sure', 'Not sure yet']
        ]
      },
      {
        id: 'development_design',
        type: 'choice',
        question: 'Do you already have the design?',
        options: [
          ['figma-ready', 'Yes, Figma is ready'],
          ['in-progress', 'Design is in progress'],
          ['need-design', 'We need design too'],
          ['no-design', 'No design needed'],
          ['not-sure', 'Not sure']
        ]
      },
      {
        id: 'development_url',
        type: 'text',
        kind: 'url',
        question: 'Share your Shopify store link so we can get some context.',
        placeholder: 'Store URL...',
        autocomplete: 'url'
      },
      {
        id: 'development_note',
        type: 'text',
        question: 'Anything technical we should know?',
        placeholder: 'Briefly describe the requirement...',
        autocomplete: 'off',
        optional: true,
        skipLabel: 'Skip'
      }
    ],

    'custom-feature': [
      {
        id: 'feature_type',
        type: 'choice',
        question: 'What kind of feature are you looking for?',
        options: [
          ['product-quiz', 'Product quiz'],
          ['product-finder', 'Product finder'],
          ['routine-builder', 'Routine builder'],
          ['shade-finder', 'Shade finder'],
          ['bundle-builder', 'Bundle builder'],
          ['custom-cart', 'Custom cart'],
          ['gift-threshold', 'Gift / threshold logic'],
          ['calculator', 'Calculator'],
          ['subscription', 'Subscription experience'],
          ['custom-app', 'Custom app'],
          ['other', 'Something else'],
          ['not-sure', 'Not sure yet']
        ]
      },
      {
        id: 'feature_example',
        type: 'choice',
        question: 'Do you have an example of how it should work?',
        options: [
          ['yes', 'Yes'],
          ['no', 'No'],
          ['explain', 'I can explain it']
        ]
      },
      {
        id: 'feature_example_url',
        type: 'text',
        kind: 'url',
        question: 'Share the example.',
        placeholder: 'Example URL...',
        autocomplete: 'url'
      },
      {
        id: 'feature_description',
        type: 'text',
        question: 'Tell me what you want it to do.',
        placeholder: 'Describe the feature...',
        autocomplete: 'off'
      },
      {
        id: 'feature_store_url',
        type: 'text',
        kind: 'url',
        question: 'What’s your Shopify store URL?',
        placeholder: 'Store URL...',
        autocomplete: 'url'
      },
      {
        id: 'feature_stage',
        type: 'choice',
        question: 'Are we starting fresh?',
        options: [
          ['fresh', 'Starting fresh'],
          ['improve', 'Existing feature needs improvement'],
          ['broken', 'Existing feature is broken'],
          ['not-sure', 'Not sure']
        ]
      }
    ],

    'store-improvement': [
      {
        id: 'improvement_area',
        type: 'choice',
        question: 'What do you want to improve most?',
        options: [
          ['product-pages', 'Product pages'],
          ['discovery', 'Navigation & product discovery'],
          ['cart', 'Cart experience'],
          ['mobile', 'Mobile UX'],
          ['landing-pages', 'Landing pages'],
          ['speed', 'Store speed'],
          ['journey', 'Overall buying journey'],
          ['not-sure', 'Not sure yet']
        ]
      },
      {
        id: 'improvement_reason',
        type: 'choice',
        question: 'What’s the main reason you want to improve it?',
        options: [
          ['low-conversion', 'Low conversion'],
          ['drop-off', 'Customers are dropping off'],
          ['mobile-weak', 'Mobile experience feels weak'],
          ['hard-to-use', 'Store is hard to use'],
          ['slow', 'Store is slow'],
          ['limited', 'Current setup feels limited'],
          ['multiple', 'More than one reason'],
          ['not-sure', 'Not sure']
        ]
      },
      {
        id: 'improvement_traffic',
        type: 'choice',
        question: 'Is the store already getting regular traffic or orders?',
        options: [
          ['yes', 'Yes'],
          ['not-really', 'Not really'],
          ['not-sure', 'Not sure']
        ]
      },
      {
        id: 'improvement_url',
        type: 'text',
        kind: 'url',
        question: 'What’s the store URL?',
        placeholder: 'Store URL...',
        autocomplete: 'url'
      }
    ],

    'store-rescue': [
      {
        id: 'rescue_issue',
        type: 'choice',
        question: 'What’s happening with the store?',
        options: [
          ['broken', 'Something is broken'],
          ['unfinished', 'Developer left it unfinished'],
          ['slow', 'Store is slow'],
          ['mobile', 'Mobile experience has issues'],
          ['apps-code', 'Apps/code are causing problems'],
          ['multiple', 'Multiple problems']
        ]
      },
      {
        id: 'rescue_impact',
        type: 'choice',
        question: 'Is this stopping customers from buying right now?',
        options: [
          ['yes', 'Yes'],
          ['partly', 'Partly'],
          ['no', 'No'],
          ['not-sure', 'Not sure']
        ]
      },
      {
        id: 'rescue_location',
        type: 'choice',
        question: 'Where is the problem happening?',
        options: [
          ['homepage', 'Homepage'],
          ['product-page', 'Product page'],
          ['collection-page', 'Collection page'],
          ['cart', 'Cart'],
          ['checkout', 'Checkout'],
          ['mobile', 'Mobile'],
          ['sitewide', 'Across the store'],
          ['not-sure', 'Not sure']
        ]
      },
      {
        id: 'rescue_url',
        type: 'text',
        kind: 'url',
        question: 'Share the store URL so we can understand what’s happening.',
        placeholder: 'Store URL...',
        autocomplete: 'url'
      },
      {
        id: 'rescue_detail',
        type: 'text',
        question: 'Anything else we should know about the issue?',
        placeholder: 'Briefly describe what’s happening...',
        autocomplete: 'off',
        optional: true,
        skipLabel: 'Skip'
      }
    ]
  };

  const unsureSteps = {
    situation: {
      id: 'unsure_situation',
      type: 'choice',
      question: 'Which one sounds closest?',
      options: [
        ['launch', 'Launch a new store'],
        ['migration', 'Move to Shopify'],
        ['improve', 'Improve my current store'],
        ['fix', 'Fix something broken'],
        ['custom', 'Build something custom'],
        ['really-unsure', 'I’m really not sure']
      ]
    },

    problem: {
      id: 'unsure_problem',
      type: 'choice',
      question: 'What feels closest to the problem?',
      options: [
        ['outdated', 'Store looks outdated'],
        ['hard-to-shop', 'Hard to shop'],
        ['low-conversion', 'Low conversion'],
        ['mobile', 'Mobile needs improvement'],
        ['slow', 'Store is slow'],
        ['multiple', 'More than one issue'],
        ['not-sure', 'Not sure']
      ]
    },

    custom: {
      id: 'unsure_custom',
      type: 'choice',
      question: 'Which one sounds closer?',
      options: [
        ['development', 'Development work'],
        ['feature', 'A specific feature'],
        ['not-sure', 'Not sure']
      ]
    },

    goal: {
      id: 'unsure_goal',
      type: 'choice',
      question: 'That’s fine. What are you trying to do right now?',
      options: [
        ['launch', 'Launch online'],
        ['migration', 'Move to Shopify'],
        ['better-look', 'Make the store look better'],
        ['easier-shopping', 'Make shopping easier'],
        ['conversion', 'Improve conversion'],
        ['fix', 'Fix a problem'],
        ['feature', 'Add a new feature'],
        ['still-unsure', 'Still not sure']
      ]
    },

    hasUrl: {
      id: 'unsure_has_url',
      type: 'choice',
      question: 'Do you have a website, store or Instagram we can look at?',
      options: [
        ['yes', 'Yes'],
        ['no', 'No']
      ]
    },

    url: {
      id: 'unsure_url',
      type: 'text',
      kind: 'url',
      question: 'Share it here and we’ll take a look.',
      placeholder: 'Website, store or Instagram URL...',
      autocomplete: 'url'
    }
  };

  const emailStep = {
    id: 'email',
    type: 'text',
    inputType: 'email',
    question: 'Would you also like to add an email?',
    placeholder: 'Email — optional...',
    autocomplete: 'email',
    optional: true,
    skipLabel: 'Skip'
  };

  const noteStep = {
    id: 'note',
    type: 'text',
    question: 'Anything else we should know?',
    placeholder: 'Add a note — optional...',
    autocomplete: 'off',
    optional: true,
    skipLabel: 'Nothing else'
  };

  const confirmStep = {
    id: 'confirm',
    type: 'choice',
    question: 'That’s enough. We can take it from here.',
    options: [
      ['submit', 'Send my enquiry']
    ]
  };

  const socialHosts = [
    'instagram.com',
    'www.instagram.com',
    'facebook.com',
    'www.facebook.com',
    'tiktok.com',
    'www.tiktok.com',
    'youtube.com',
    'www.youtube.com',
    'youtu.be',
    'linkedin.com',
    'www.linkedin.com',
    'x.com',
    'www.x.com',
    'twitter.com',
    'www.twitter.com',
    'pinterest.com',
    'www.pinterest.com',
    'threads.net',
    'www.threads.net'
  ];

  const effectiveService = (state) => {
    if (state.service !== 'unsure') {
      return state.service;
    }

    const situation =
      state.answers.unsure_situation;

    if (situation === 'launch') {
      return 'new-store';
    }

    if (situation === 'migration') {
      return 'migration';
    }

    if (situation === 'fix') {
      return 'store-rescue';
    }

    if (situation === 'custom') {
      const custom =
        state.answers.unsure_custom;

      if (custom === 'feature') {
        return 'custom-feature';
      }

      if (
        custom === 'development' ||
        custom === 'not-sure'
      ) {
        return 'custom-development';
      }

      return 'unsure';
    }

    if (situation === 'improve') {
      const problem =
        state.answers.unsure_problem;

      if (!problem) {
        return 'unsure';
      }

      return problem === 'outdated'
        ? 'redesign'
        : 'store-improvement';
    }

    if (situation === 'really-unsure') {
      const goal =
        state.answers.unsure_goal;

      const map = {
        launch: 'new-store',
        migration: 'migration',
        'better-look': 'redesign',
        'easier-shopping': 'store-improvement',
        conversion: 'store-improvement',
        fix: 'store-rescue',
        feature: 'custom-feature'
      };

      return map[goal] || 'unsure';
    }

    return 'unsure';
  };

  const serviceOpening = (
    service
  ) => {
    const openings = {
      'new-store':
        'Looks like you want to build a new Shopify store. I’ll ask a few quick questions to understand it better.',
      migration:
        'Looks like you want to move your store to Shopify. I’ll get a few details first.',
      redesign:
        'Looks like you want to redesign your Shopify store. I’ll ask a few quick questions to understand it better.',
      'custom-development':
        'Looks like you need custom Shopify development. I’ll ask a few quick questions first.',
      'custom-feature':
        'Looks like you want to build something custom in Shopify. Let me understand what you need.',
      'store-improvement':
        'Looks like you want to improve your Shopify store. Let’s find the main area to focus on.',
      'store-rescue':
        'Looks like something isn’t working properly in your Shopify store. Let’s understand the issue.',
      unsure:
        'That’s okay. You don’t need to know the exact Shopify service. Just tell me what you’re trying to do.'
    };

    return openings[service] || '';
  };

  const budgetOptionsFor = (
    state
  ) => {
    const service =
      effectiveService(state);

    if (service === 'new-store') {
      return budgetsNewStore;
    }

    if (
      service === 'custom-feature'
    ) {
      return budgetsFeature;
    }

    if (
      service === 'store-improvement' ||
      service === 'store-rescue'
    ) {
      return budgetsSmall;
    }

    return budgetsFull;
  };

  const needsNote = (
    state
  ) => {
    const service =
      effectiveService(state);

    if (
      state.service === 'unsure' &&
      service === 'unsure'
    ) {
      return true;
    }

    return [
      'new-store',
      'migration',
      'redesign'
    ].includes(service);
  };

  const needsConfirm = (
    state
  ) =>
    state.service === 'unsure' &&
    effectiveService(state) === 'unsure';

  const normalizeUrl = (
    value
  ) => {
    const clean =
      String(value || '').trim();

    if (!clean) {
      return '';
    }

    if (
      /^https?:\/\//i.test(clean)
    ) {
      return clean;
    }

    return `https://${clean}`;
  };

  const parsePublicUrl = (
    value
  ) => {
    try {
      const normalized =
        normalizeUrl(value);

      const url =
        new URL(normalized);

      if (
        url.protocol !== 'https:' &&
        url.protocol !== 'http:'
      ) {
        return null;
      }

      const hostname =
        url.hostname
          .toLowerCase()
          .replace(/\.$/, '');

      if (
        !hostname ||
        hostname === 'localhost' ||
        hostname.endsWith('.local') ||
        hostname.endsWith('.test') ||
        hostname.endsWith('.example')
      ) {
        return null;
      }

      if (
        /^\d{1,3}(?:\.\d{1,3}){3}$/
          .test(hostname) ||
        hostname.includes(':')
      ) {
        return null;
      }

      const parts =
        hostname.split('.');

      if (
        parts.length < 2
      ) {
        return null;
      }

      const tld =
        parts[
        parts.length - 1
        ];

      if (
        !/^[a-z]{2,24}$/i.test(
          tld
        )
      ) {
        return null;
      }

      return {
        url,
        hostname
      };
    } catch (error) {
      return null;
    }
  };

  const makeId = () => {
    if (
      window.crypto &&
      typeof window.crypto.randomUUID ===
      'function'
    ) {
      return window.crypto.randomUUID();
    }

    return `${Date.now()}-${Math.random()
      .toString(16)
      .slice(2)}`;
  };

  const clone = (value) =>
    JSON.parse(
      JSON.stringify(value)
    );

  const tracking = () => {
    const params =
      new URLSearchParams(
        location.search
      );

    return {
      page_url:
        location.href,
      page_path:
        location.pathname,
      referrer:
        document.referrer || '',
      utm_source:
        params.get(
          'utm_source'
        ) || '',
      utm_medium:
        params.get(
          'utm_medium'
        ) || '',
      utm_campaign:
        params.get(
          'utm_campaign'
        ) || '',
      utm_content:
        params.get(
          'utm_content'
        ) || '',
      utm_term:
        params.get(
          'utm_term'
        ) || '',
      gclid:
        params.get(
          'gclid'
        ) || '',
      fbclid:
        params.get(
          'fbclid'
        ) || ''
    };
  };

  const flagFromCountry = (
    country
  ) => {
    if (
      !country ||
      country.length !== 2
    ) {
      return '🌐';
    }

    return country
      .toUpperCase()
      .replace(
        /./g,
        (character) =>
          String.fromCodePoint(
            127397 +
            character.charCodeAt()
          )
      );
  };





  const flagImageFromCountry = (
    country,
    className = ''
  ) => {
    if (
      !country ||
      country.length !== 2
    ) {
      return '';
    }

    const code =
      country.toLowerCase();

    return `
    <img
      class="${className}"
      src="https://flagcdn.com/w40/${code}.png"
      srcset="https://flagcdn.com/w80/${code}.png 2x"
      width="20"
      height="15"
      alt=""
      loading="lazy"
      decoding="async"
    >
  `;
  };


  const noticeIcons = {
    error: `
      <svg viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5"/>
        <path d="M10 6.4v4.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="10" cy="13.7" r=".8" fill="currentColor"/>
      </svg>
    `,

    info: `
      <svg viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5"/>
        <path d="M10 9.2v4.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="10" cy="6.6" r=".8" fill="currentColor"/>
      </svg>
    `,

    success: `
      <svg viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5"/>
        <path d="m6.8 10 2 2 4.4-4.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `
  };

  roots.forEach(
    (root) => {
      root.dataset
        .lpQualifierReady =
        'true';

      const dialog =
        root.querySelector(
          '[data-lp-qualifier-dialog]'
        );

      const conversation =
        root.querySelector(
          '[data-lp-qualifier-conversation]'
        );

      const composer =
        root.querySelector(
          '[data-lp-qualifier-composer]'
        );

      const input =
        root.querySelector(
          '[data-lp-qualifier-input]'
        );

      const send =
        root.querySelector(
          '[data-lp-qualifier-send]'
        );

      const close =
        root.querySelector(
          '[data-lp-qualifier-close]'
        );

      const back =
        root.querySelector(
          '[data-lp-qualifier-back]'
        );

      const helper =
        root.querySelector(
          '[data-lp-qualifier-helper]'
        );

      const progress =
        root.querySelector(
          '[data-lp-qualifier-progress]'
        );

      const notice =
        root.querySelector(
          '[data-lp-qualifier-notice]'
        );

      const noticeIcon =
        root.querySelector(
          '[data-lp-qualifier-notice-icon]'
        );

      const noticeText =
        root.querySelector(
          '[data-lp-qualifier-notice-text]'
        );

      const soundToggle =
        root.querySelector(
          '[data-lp-qualifier-sound]'
        );

      const countryOpen =
        root.querySelector(
          '[data-lp-country-open]'
        );

      const countryPicker =
        root.querySelector(
          '[data-lp-country-picker]'
        );

      const countryClose =
        root.querySelector(
          '[data-lp-country-close]'
        );

      const countrySearch =
        root.querySelector(
          '[data-lp-country-search]'
        );

      const countryList =
        root.querySelector(
          '[data-lp-country-list]'
        );

      const countryEmpty =
        root.querySelector(
          '[data-lp-country-empty]'
        );

      const countryFlag =
        root.querySelector(
          '[data-lp-country-flag]'
        );

      const countryCode =
        root.querySelector(
          '[data-lp-country-code]'
        );

      if (
        !dialog ||
        !conversation ||
        !composer ||
        !input ||
        !send
      ) {
        return;
      }

      const apiBase =
        (
          root.dataset.apiBase ||
          ''
        ).replace(
          /\/$/,
          ''
        );

      const frontendPreviewMode =
        root.dataset.previewMode ===
        'true';

      const backendEnabled =
        Boolean(apiBase) &&
        !frontendPreviewMode;

      const bookingUrl =
        root.dataset.bookingUrl ||
        '';

      const whatsappNumber =
        (
          root.dataset
            .whatsappNumber ||
          ''
        ).replace(
          /\D/g,
          ''
        );

      let audioContext =
        null;

      let audioUnlocked =
        false;

      let interacted =
        false;

      let soundEnabled =
        root.dataset.soundDefault !==
        'off';

      let countries =
        fallbackCountries.map(
          ([country, name, callingCode]) => ({
            country,
            name,
            calling_code:
              callingCode
          })
        );

      const baseState = () => ({
        sessionId: makeId(),
        openedAt: Date.now(),

        source: '',
        sourceCta: '',
        sourceContext: '',

        servicePreset: false,

        current: 'service',

        firstName: '',

        country: 'IN',
        countryName: 'India',
        callingCode: '+91',
        flag: '🇮🇳',

        localPhone: '',
        phone: '',

        service: '',
        budget: '',
        timeline: '',

        answers: {},

        email: '',
        url: '',
        note: '',

        leadId: '',
        leadToken: '',

        completed: false,

        transcript: [],
        history: []
      });

      let state =
        baseState();

      let saveQueue =
        Promise.resolve();

      let busy = false;

      const setNotice = (
        type = '',
        message = ''
      ) => {
        if (
          !notice ||
          !noticeIcon ||
          !noticeText
        ) {
          return;
        }

        notice.classList.remove(
          'lp-chat-notice--error',
          'lp-chat-notice--info',
          'lp-chat-notice--success'
        );

        if (!message) {
          notice.hidden = true;
          noticeText.textContent =
            '';

          noticeIcon.innerHTML =
            '';

          return;
        }

        notice.classList.add(
          `lp-chat-notice--${type}`
        );

        noticeIcon.innerHTML =
          noticeIcons[type] ||
          noticeIcons.info;

        noticeText.textContent =
          message;

        notice.hidden = false;
      };

      const setSoundUI = () => {
        if (!soundToggle) return;

        soundToggle.setAttribute(
          'aria-pressed',
          soundEnabled
            ? 'true'
            : 'false'
        );

        soundToggle.setAttribute(
          'aria-label',
          soundEnabled
            ? 'Turn message sound off'
            : 'Turn message sound on'
        );
      };

      const unlockAudio = () => {
        if (!soundEnabled) {
          return null;
        }

        try {
          if (!audioContext) {
            const AudioContext =
              window.AudioContext ||
              window.webkitAudioContext;

            if (!AudioContext) {
              return null;
            }

            audioContext =
              new AudioContext();
          }

          if (
            audioContext.state ===
            'suspended'
          ) {
            audioContext
              .resume()
              .catch(() => { });
          }

          audioUnlocked = true;

          return audioContext;
        } catch (error) {
          return null;
        }
      };

      const tone = (
        frequency,
        startOffset,
        duration,
        volume
      ) => {
        const context =
          unlockAudio();

        if (
          !context ||
          !audioUnlocked
        ) {
          return;
        }

        const oscillator =
          context.createOscillator();

        const gain =
          context.createGain();

        oscillator.type =
          'sine';

        oscillator.frequency.value =
          frequency;

        const start =
          context.currentTime +
          startOffset;

        const end =
          start +
          duration;

        gain.gain.setValueAtTime(
          0.0001,
          start
        );

        gain.gain.exponentialRampToValueAtTime(
          Math.max(
            volume,
            0.001
          ),
          start + 0.012
        );

        gain.gain.exponentialRampToValueAtTime(
          0.0001,
          end
        );

        oscillator.connect(
          gain
        );

        gain.connect(
          context.destination
        );

        oscillator.start(
          start
        );

        oscillator.stop(
          end + 0.02
        );
      };

      const playEntranceSound =
        () => {
          if (!soundEnabled) return;

          tone(
            480,
            0,
            .08,
            .07
          );

          tone(
            650,
            .055,
            .1,
            .055
          );
        };

      const playMessageSound =
        () => {
          if (!soundEnabled) return;

          tone(
            560,
            0,
            .07,
            .045
          );
        };

      const playSuccessSound =
        () => {
          if (!soundEnabled) return;

          tone(
            520,
            0,
            .09,
            .055
          );

          tone(
            660,
            .075,
            .11,
            .06
          );

          tone(
            820,
            .15,
            .14,
            .055
          );
        };

      const scrollBottom = () => {
        requestAnimationFrame(
          () => {
            conversation.scrollTo({
              top:
                conversation
                  .scrollHeight,

              behavior:
                reducedMotion.matches
                  ? 'auto'
                  : 'smooth'
            });
          }
        );
      };

      const avatarMarkup =
        () => {
          const avatar =
            root.querySelector(
              '.lp-chat-qualifier__avatar'
            );

          return avatar
            ? avatar.innerHTML
            : '<span>L+</span>';
        };

      const addMessage = (
        role,
        text,
        {
          record = true,
          sound = false
        } = {}
      ) => {
        const row =
          document.createElement(
            'div'
          );

        row.className =
          `lp-chat-message lp-chat-message--${role}`;

        if (
          role ===
          'assistant'
        ) {
          const avatar =
            document.createElement(
              'span'
            );

          avatar.className =
            'lp-chat-message__avatar';

          avatar.setAttribute(
            'aria-hidden',
            'true'
          );

          avatar.innerHTML =
            avatarMarkup();

          row.appendChild(
            avatar
          );
        }

        const bubble =
          document.createElement(
            'div'
          );

        bubble.className =
          'lp-chat-message__bubble';

        const paragraph =
          document.createElement(
            'p'
          );

        paragraph.textContent =
          text;

        bubble.appendChild(
          paragraph
        );

        row.appendChild(
          bubble
        );

        conversation.appendChild(
          row
        );

        if (record) {
          state.transcript.push({
            role,
            text
          });
        }

        if (
          role ===
          'assistant' &&
          sound
        ) {
          playMessageSound();
        }

        scrollBottom();
      };

      const addTyping = () => {
        const row =
          document.createElement(
            'div'
          );

        row.className =
          'lp-chat-message lp-chat-message--assistant';

        row.dataset.lpTyping =
          'true';

        row.setAttribute(
          'aria-hidden',
          'true'
        );

        const avatar =
          document.createElement(
            'span'
          );

        avatar.className =
          'lp-chat-message__avatar';

        avatar.innerHTML =
          avatarMarkup();

        const typing =
          document.createElement(
            'span'
          );

        typing.className =
          'lp-chat-typing';

        typing.innerHTML =
          '<span></span><span></span><span></span>';

        row.append(
          avatar,
          typing
        );

        conversation.appendChild(
          row
        );

        scrollBottom();

        return row;
      };

      const waitForAssistant =
        async () => {
          const typing =
            addTyping();

          const delay =
            reducedMotion.matches
              ? 80
              : 300 +
              Math.floor(
                Math.random() *
                150
              );

          await new Promise(
            (resolve) =>
              setTimeout(
                resolve,
                delay
              )
          );

          typing.remove();
        };

      const updateCountryUI = () => {
        if (countryFlag) {
          countryFlag.innerHTML =
            flagImageFromCountry(
              state.country,
              'lp-chat-qualifier__country-flag-image'
            );
        }

        if (countryCode) {
          countryCode.textContent =
            state.callingCode;
        }
      };

      const closeCountryPicker =
        () => {
          if (!countryPicker) {
            return;
          }

          countryPicker.hidden =
            true;

          countryOpen?.setAttribute(
            'aria-expanded',
            'false'
          );
        };

      const renderCountries =
        (query = '') => {
          if (
            !countryList ||
            !countryEmpty
          ) {
            return;
          }

          const normalized =
            query
              .trim()
              .toLowerCase();

          const filtered =
            countries.filter(
              (item) => {
                if (!normalized) {
                  return true;
                }

                return (
                  item.name
                    .toLowerCase()
                    .includes(
                      normalized
                    ) ||
                  item.country
                    .toLowerCase()
                    .includes(
                      normalized
                    ) ||
                  item.calling_code
                    .replace(
                      /\s/g,
                      ''
                    )
                    .includes(
                      normalized.replace(
                        /\s/g,
                        ''
                      )
                    )
                );
              }
            );

          const fragment =
            document.createDocumentFragment();

          filtered.forEach(
            (item) => {
              const button =
                document.createElement(
                  'button'
                );

              button.type =
                'button';

              button.className =
                'lp-chat-country__item';

              button.setAttribute(
                'role',
                'option'
              );

              button.dataset.country =
                item.country;

              button.dataset.countryName =
                item.name;

              button.dataset.callingCode =
                item.calling_code;

              button.innerHTML = `
  <span class="lp-chat-country__item-flag">
    ${flagImageFromCountry(
                item.country,
                'lp-chat-country__flag-image'
              )}
  </span>

  <span class="lp-chat-country__item-name"></span>

  <span class="lp-chat-country__item-code"></span>
`;

              button.querySelector(
                '.lp-chat-country__item-name'
              ).textContent =
                item.name;

              button.querySelector(
                '.lp-chat-country__item-code'
              ).textContent =
                item.calling_code;

              fragment.appendChild(
                button
              );
            }
          );

          countryList.replaceChildren(
            fragment
          );

          countryEmpty.hidden =
            filtered.length > 0;
        };

      const loadCountries =
        async () => {
          if (!backendEnabled) {
            return countries;
          }

          try {
            const response =
              await fetch(
                `${apiBase}/v1/meta/countries`,
                {
                  method: 'GET',
                  credentials: 'omit'
                }
              );

            if (!response.ok) {
              throw new Error(
                'Countries endpoint unavailable.'
              );
            }

            const data =
              await response.json();

            if (
              Array.isArray(
                data.countries
              ) &&
              data.countries
                .length
            ) {
              countries =
                data.countries
                  .map(
                    (item) => ({
                      country:
                        String(
                          item.country ||
                          ''
                        )
                          .trim()
                          .toUpperCase(),

                      name:
                        String(
                          item.name ||
                          ''
                        ).trim(),

                      calling_code:
                        String(
                          item.calling_code ||
                          ''
                        ).trim()
                    })
                  )
                  .filter(
                    (item) =>
                      item.country &&
                      item.name &&
                      item.calling_code
                  );
            }
          } catch (error) {
            /* Optimized local fallback stays available. */
          }

          return countries;
        };

      const openCountryPicker =
        async () => {
          if (!countryPicker) {
            return;
          }

          interacted = true;
          unlockAudio();

          countryPicker.hidden =
            false;

          countryOpen?.setAttribute(
            'aria-expanded',
            'true'
          );

          countrySearch.value =
            '';

          renderCountries();

          await loadCountries();

          renderCountries();

          window.setTimeout(
            () =>
              countrySearch?.focus({
                preventScroll: true
              }),
            20
          );
        };

      const setComposerMode =
        (step) => {
          const isPhone =
            step?.id ===
            'phone';

          composer.classList.toggle(
            'is-phone',
            isPhone
          );

          if (countryOpen) {
            countryOpen.hidden =
              !isPhone;
          }

          if (!isPhone) {
            closeCountryPicker();
          }
        };

      const disableComposer = (
        placeholder =
          'Select an option to continue'
      ) => {
        input.value = '';

        input.disabled = true;
        send.disabled = true;

        input.placeholder =
          placeholder;

        input.type = 'text';
        input.inputMode = '';
        input.autocomplete =
          'off';

        setComposerMode(null);

        if (helper) {
          helper.textContent =
            'Select an option to continue';
        }
      };

      const enableComposer =
        (step) => {
          setComposerMode(step);

          input.disabled =
            false;

          send.disabled =
            true;

          input.value = '';

          input.placeholder =
            step.placeholder ||
            'Type your answer…';

          input.type =
            step.id === 'phone'
              ? 'tel'
              : step.inputType ||
              'text';

          input.autocomplete =
            step.autocomplete ||
            'off';

          input.inputMode =
            step.id === 'phone'
              ? 'numeric'
              : step.inputType ===
                'email'
                ? 'email'
                : 'text';

          if (helper) {
            if (step.helper) {
              helper.textContent =
                step.helper;
            } else if (
              step.optional
            ) {
              helper.textContent =
                'Optional';
            } else {
              helper.textContent =
                'Type below and send';
            }
          }

          window.setTimeout(
            () =>
              input.focus({
                preventScroll: true
              }),
            70
          );
        };

      const removeOptions =
        () => {
          conversation
            .querySelectorAll(
              '[data-lp-chat-options]'
            )
            .forEach(
              (element) =>
                element.remove()
            );
        };

      const addOptions = (
        options,
        {
          skipLabel = ''
        } = {}
      ) => {
        removeOptions();

        const wrapper =
          document.createElement(
            'div'
          );

        wrapper.className =
          'lp-chat-options';

        wrapper.dataset
          .lpChatOptions =
          'true';

        const allOptions =
          [...options];

        if (skipLabel) {
          allOptions.push([
            '__skip__',
            skipLabel
          ]);
        }

        allOptions.forEach(
          ([value, label]) => {
            const button =
              document.createElement(
                'button'
              );

            button.type =
              'button';

            button.className =
              'lp-chat-option';

            button.dataset.value =
              value;

            button.textContent =
              label;

            wrapper.appendChild(
              button
            );
          }
        );

        conversation.appendChild(
          wrapper
        );

        scrollBottom();
      };

      const unsurePrefix = () => {
        const steps = [
          unsureSteps.situation.id
        ];

        const situation =
          state.answers
            .unsure_situation;

        if (
          situation === 'improve'
        ) {
          steps.push(
            unsureSteps.problem.id
          );
        }

        if (
          situation === 'custom'
        ) {
          steps.push(
            unsureSteps.custom.id
          );
        }

        if (
          situation ===
          'really-unsure'
        ) {
          steps.push(
            unsureSteps.goal.id
          );

          if (
            state.answers
              .unsure_goal ===
            'still-unsure'
          ) {
            steps.push(
              unsureSteps.hasUrl.id
            );

            if (
              state.answers
                .unsure_has_url ===
              'yes'
            ) {
              steps.push(
                unsureSteps.url.id
              );
            }
          }
        }

        return steps;
      };

      const branch = () =>
        branchSteps[
        effectiveService(state)
        ] || [];

      const branchSequence = () => {
        const prefix =
          state.service === 'unsure'
            ? unsurePrefix()
            : [];

        const resolved =
          effectiveService(state);

        if (
          resolved === 'unsure'
        ) {
          return prefix;
        }

        let branchIds =
          (
            branchSteps[
            resolved
            ] || []
          ).map(
            (step) => step.id
          );

        if (
          resolved ===
          'new-store' &&
          state.answers
            .new_store_presence ===
          'nothing'
        ) {
          branchIds =
            branchIds.filter(
              (id) =>
                id !==
                'new_store_url'
            );
        }

        if (
          state.service === 'redesign' &&
          state.answers.redesign_live === 'no'
        ) {
          branchIds = branchIds.filter(
            (id) => id !== 'redesign_url'
          );
        }

        if (
          resolved ===
          'custom-feature'
        ) {
          branchIds =
            branchIds.filter(
              (id) => {
                if (
                  id ===
                  'feature_example_url'
                ) {
                  return (
                    state.answers
                      .feature_example ===
                    'yes'
                  );
                }

                if (
                  id ===
                  'feature_description'
                ) {
                  return (
                    state.answers
                      .feature_example ===
                    'explain'
                  );
                }

                return true;
              }
            );
        }

        return [
          ...prefix,
          ...branchIds
        ];
      };



      const sequence = () => {
        const steps = [];

        if (!state.servicePreset) {
          steps.push('service');
        }

        if (state.unsureWhatsAppRoute) {
          steps.push('phone');
          return steps;
        }

        steps.push(
          'first_name',
          'phone'
        );

        branchSequence().forEach((id) => {
          steps.push(id);
        });

        steps.push(
          'timeline',
          'budget'
        );

        steps.push(
          'email'
        );

        if (needsNote(state)) {
          steps.push('note');
        }

        if (needsConfirm(state)) {
          steps.push('confirm');
        }

        return steps;
      };

      const currentIndex =
        () => {
          const steps =
            sequence();

          const index =
            steps.indexOf(
              state.current
            );

          return index < 0
            ? 0
            : index;
        };

      const updateProgress =
        () => {
          const steps =
            sequence();

          const index =
            currentIndex();

          const ratio =
            state.completed
              ? 1
              : Math.min(
                (
                  index +
                  .35
                ) /
                Math.max(
                  steps.length,
                  1
                ),
                .96
              );

          progress.style.transform =
            `scaleX(${ratio})`;

          back.hidden =
            state.history
              .length === 0 ||
            state.completed;
        };

      const getBranchStep = (
        id
      ) => {
        const all =
          Object.values(
            branchSteps
          ).flat();

        return all.find(
          (step) =>
            step.id === id
        );
      };

      const getUnsureStep = (
        id
      ) =>
        Object.values(
          unsureSteps
        ).find(
          (step) =>
            step.id === id
        );

      const getStep = (
        id
      ) => {
        if (
          id === 'service'
        ) {
          return {
            id,
            type: 'choice',
            question:
              'What are you looking to do?',
            options:
              services
          };
        }

        if (
          id ===
          'first_name'
        ) {
          return {
            id,
            type: 'text',
            question:
              'First, what’s your name?',
            placeholder:
              'First name...',
            autocomplete:
              'given-name'
          };
        }

        if (
          id === 'timeline'
        ) {
          const service =
            effectiveService(state);

          let question =
            `Thanks, ${state.firstName}. When do you want to start?`;

          if (
            service === 'migration'
          ) {
            question =
              `Thanks, ${state.firstName}. When do you want to start the migration?`;
          } else if (
            service ===
            'store-rescue'
          ) {
            question =
              `Thanks, ${state.firstName}. How soon do you want this fixed?`;
          } else if (
            state.service ===
            'unsure' &&
            service === 'unsure'
          ) {
            question =
              `Thanks, ${state.firstName}. When are you thinking about starting?`;
          }

          return {
            id,
            type: 'choice',
            question,
            options:
              timelines
          };
        }

        if (
          id === 'budget'
        ) {
          const service =
            effectiveService(state);

          let question =
            `What budget are you thinking about, ${state.firstName}?`;

          if (
            service === 'new-store' ||
            service === 'redesign'
          ) {
            question =
              `And what budget are you thinking about, ${state.firstName}?`;
          }

          if (
            state.service ===
            'unsure' &&
            service === 'unsure'
          ) {
            question =
              `Do you have a budget in mind, ${state.firstName}?`;
          }

          return {
            id,
            type: 'choice',
            question,
            options:
              budgetOptionsFor(state)
          };
        }

        if (
          id === 'phone'
        ) {
          return {
            id,
            type: 'text',
            inputType: 'tel',
            question:
              'What’s the best WhatsApp number to reach you on?',
            placeholder:
              'WhatsApp number...',
            autocomplete:
              'tel-national',
            helper:
              'We may contact you about this enquiry by WhatsApp or phone. No OTP needed.'
          };
        }

        if (
          id === 'email'
        ) {
          return emailStep;
        }

        if (
          id === 'note'
        ) {
          return noteStep;
        }

        if (
          id === 'confirm'
        ) {
          return confirmStep;
        }

        return (
          getUnsureStep(id) ||
          getBranchStep(id)
        );
      };

      const nextStepId =
        () => {
          const steps =
            sequence();

          const index =
            currentIndex();

          return (
            steps[
            index + 1
            ] ||
            'complete'
          );
        };

      const snapshot =
        () =>
          clone({
            ...state,
            history: []
          });

      const restoreSnapshot =
        (value) => {
          const history =
            state.history;

          state = {
            ...value,
            history
          };

          updateCountryUI();
        };

      const renderTranscript =
        () => {
          conversation.innerHTML =
            '';

          state.transcript.forEach(
            (message) =>
              addMessage(
                message.role,
                message.text,
                {
                  record: false
                }
              )
          );
        };

      const api = async (
        path,
        options = {}
      ) => {
        if (!backendEnabled) {
          return {
            preview: true
          };
        }

        const headers = {
          'Content-Type':
            'application/json',
          ...options.headers
        };

        if (
          state.leadToken
        ) {
          headers[
            'X-Lead-Token'
          ] =
            state.leadToken;
        }

        const response =
          await fetch(
            `${apiBase}${path}`,
            {
              ...options,
              headers,
              credentials: 'omit'
            }
          );

        const data =
          await response
            .json()
            .catch(
              () => ({})
            );

        if (!response.ok) {
          const error =
            new Error(
              data.message ||
              'We could not save your enquiry.'
            );

          error.data =
            data;

          throw error;
        }

        return data;
      };

      const fullPhone = () =>
        `${state.callingCode}${state.localPhone}`;

      const leadPayload =
        () => ({
          session_id:
            state.sessionId,

          service:
            effectiveService(state),

          budget:
            state.budget,

          first_name:
            state.firstName,

          country:
            state.country,

          calling_code:
            state.callingCode,

          phone:
            fullPhone(),

          timeline:
            state.timeline,

          answers:
            state.answers,

          url:
            state.url,

          email:
            state.email,

          note:
            state.note,

          source:
            state.source,

          source_cta:
            state.sourceCta,

          source_context:
            state.sourceContext,

          ...tracking()
        });

      const startLead =
        async () => {
          if (
            state.leadId ||
            !backendEnabled
          ) {
            return;
          }

          const result =
            await api(
              '/v1/leads/start',
              {
                method:
                  'POST',

                body:
                  JSON.stringify(
                    leadPayload()
                  )
              }
            );

          state.leadId =
            result.lead_id;

          state.leadToken =
            result.token;
        };

      const queueSave =
        () => {
          if (
            !state.leadId ||
            !backendEnabled
          ) {
            return Promise.resolve();
          }

          saveQueue =
            saveQueue
              .catch(
                () => { }
              )
              .then(
                () =>
                  api(
                    `/v1/leads/${encodeURIComponent(
                      state.leadId
                    )}`,
                    {
                      method:
                        'PATCH',

                      body:
                        JSON.stringify(
                          leadPayload()
                        )
                    }
                  )
              );

          return saveQueue;
        };

      const completeLead =
        async () => {
          if (!backendEnabled) {
            return {
              preview: true
            };
          }

          if (!state.leadId) {
            await startLead();
          }

          await saveQueue.catch(
            () => { }
          );

          return api(
            `/v1/leads/${encodeURIComponent(
              state.leadId
            )}/complete`,
            {
              method:
                'POST',

              body:
                JSON.stringify(
                  leadPayload()
                )
            }
          );
        };

      const validateText =
        (step, value) => {
          const clean =
            value.trim();

          if (
            !clean &&
            !step.optional
          ) {
            return {
              type: 'error',
              message:
                'Please enter an answer before sending.'
            };
          }

          if (
            step.id ===
            'first_name'
          ) {
            if (
              clean.length < 2
            ) {
              return {
                type: 'error',
                message:
                  'Please enter your first name.'
              };
            }

            if (
              clean.length > 60
            ) {
              return {
                type: 'error',
                message:
                  'Please keep your first name under 60 characters.'
              };
            }

            if (
              !/^[\p{L}\p{M} .'-]+$/u.test(
                clean
              )
            ) {
              return {
                type: 'error',
                message:
                  'Please enter a valid name using letters only.'
              };
            }
          }

          if (step.id === 'phone') {
            const digits =
              clean.replace(/\D/g, '');

            const phoneRules = {
              IN: {
                length: 10,
                pattern: /^[6-9]\d{9}$/,
                message:
                  'Enter a valid 10-digit Indian mobile number'
              },

              US: {
                length: 10,
                pattern: /^[2-9]\d{2}[2-9]\d{6}$/,
                message:
                  'Enter a valid 10-digit US phone number.'
              },

              CA: {
                length: 10,
                pattern: /^[2-9]\d{2}[2-9]\d{6}$/,
                message:
                  'Enter a valid 10-digit Canadian phone number.'
              },

              GB: {
                minLength: 10,
                maxLength: 10,
                pattern: /^7\d{9}$/,
                message:
                  'Enter a valid UK mobile number'
              },

              AU: {
                length: 9,
                pattern: /^4\d{8}$/,
                message:
                  'Enter a valid Australian mobile number'
              },

              AE: {
                length: 9,
                pattern: /^5\d{8}$/,
                message:
                  'Enter a valid UAE mobile number'
              },

              ZA: {
                length: 9,
                pattern: /^[6-8]\d{8}$/,
                message:
                  'Enter a valid South African mobile number.'
              },

              SG: {
                length: 8,
                pattern: /^[689]\d{7}$/,
                message:
                  'Enter a valid Singapore mobile number.'
              },

              NZ: {
                minLength: 8,
                maxLength: 10,
                pattern: /^2\d{7,9}$/,
                message:
                  'Enter a valid New Zealand mobile number'
              }
            };

            const rule =
              phoneRules[state.country];

            if (rule) {
              if (
                rule.length &&
                digits.length !== rule.length
              ) {
                return {
                  type: 'error',
                  message: rule.message
                };
              }

              if (
                rule.minLength &&
                digits.length < rule.minLength
              ) {
                return {
                  type: 'error',
                  message: rule.message
                };
              }

              if (
                rule.maxLength &&
                digits.length > rule.maxLength
              ) {
                return {
                  type: 'error',
                  message: rule.message
                };
              }

              if (
                rule.pattern &&
                !rule.pattern.test(digits)
              ) {
                return {
                  type: 'error',
                  message: rule.message
                };
              }
            } else {
              if (
                digits.length < 6 ||
                digits.length > 14
              ) {
                return {
                  type: 'error',
                  message:
                    'Enter a valid mobile number for the selected country.'
                };
              }
            }
          }

          if (
            step.id ===
            'email' &&
            clean
          ) {
            const valid =
              /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                .test(clean);

            if (!valid) {
              return {
                type: 'error',
                message:
                  'Please enter a valid email address or choose Skip email.'
              };
            }
          }

          if (
            step.kind === 'url'
          ) {
            const parsed =
              parsePublicUrl(
                clean
              );

            if (!parsed) {
              return {
                type: 'error',
                message:
                  'Please enter a valid public link'
              };
            }
          }

          if (
            step.id ===
            'note' &&
            clean.length > 1000
          ) {
            return {
              type: 'error',
              message:
                'Please keep the note under 1,000 characters.'
            };
          }

          return null;
        };

      const saveAnswer = (
        step,
        value,
        label = value
      ) => {
        if (
          step.id ===
          'service'
        ) {
          state.service =
            value;

          state.unsureWhatsAppRoute =
            !state.servicePreset &&
            value === 'unsure';
        } else if (
          step.id ===
          'budget'
        ) {
          state.budget =
            value;
        } else if (
          step.id ===
          'first_name'
        ) {
          state.firstName =
            value;
        } else if (
          step.id ===
          'phone'
        ) {
          state.localPhone =
            value.replace(
              /\D/g,
              ''
            );

          state.phone =
            fullPhone();
        } else if (
          step.id ===
          'timeline'
        ) {
          state.timeline =
            value;
        } else if (
          step.id ===
          'email'
        ) {
          state.email =
            value;
        } else if (
          step.id ===
          'note'
        ) {
          state.note =
            value;
        } else if (
          step.kind ===
          'url'
        ) {
          const normalized =
            normalizeUrl(value);

          state.answers[
            step.id
          ] = normalized;

          if (
            !state.url ||
            [
              'migration_url',
              'redesign_url',
              'development_url',
              'feature_store_url',
              'improvement_url',
              'rescue_url',
              'new_store_url',
              'unsure_url'
            ].includes(step.id)
          ) {
            state.url =
              normalized;
          }
        } else if (
          step.id !==
          'confirm'
        ) {
          state.answers[
            step.id
          ] = value;
        }

        addMessage(
          'user',
          step.id === 'phone'
            ? `${state.callingCode} ${state.localPhone}`
            : label ||
            'Skipped'
        );
      };

      const renderStep =
        async (
          {
            initial = false
          } = {}
        ) => {
          setNotice();

          removeOptions();

          updateProgress();

          const step =
            getStep(
              state.current
            );

          if (!step) return;

          if (!initial) {
            await waitForAssistant();
          }

          addMessage(
            'assistant',
            step.question,
            {
              sound:
                !initial
            }
          );

          if (
            step.type ===
            'choice'
          ) {
            disableComposer();

            addOptions(
              step.options
            );
          } else {
            enableComposer(
              step
            );

            if (
              step.optional &&
              step.skipLabel
            ) {
              addOptions(
                [],
                {
                  skipLabel:
                    step.skipLabel
                }
              );
            }

            if (
              step.id ===
              'phone'
            ) {
              setNotice(
                'info',
                'Select your country code, then enter your WhatsApp number.'
              );
            }
          }
        };

      const renderFinal =
        async () => {
          state.completed =
            true;

          removeOptions();
          closeCountryPicker();

          root.classList.add(
            'is-complete'
          );

          input.value = '';
          input.disabled = true;
          send.disabled = true;

          if (helper) {
            helper.textContent = '';
          }

          back.hidden = true;

          updateProgress();

          await waitForAssistant();

          playSuccessSound();

          const final =
            document.createElement(
              'div'
            );

          final.className =
            'lp-chat-final lp-chat-final--success';

          final.innerHTML = `
            <div class="lp-chat-final__success-icon" aria-hidden="true">
              <svg viewBox="0 0 48 48" fill="none">
                <circle
                  class="lp-chat-final__success-circle"
                  cx="24"
                  cy="24"
                  r="19"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <path
                  class="lp-chat-final__success-check"
                  d="m15.5 24.5 5.5 5.5 11.5-12"
                  stroke="currentColor"
                  stroke-width="2.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div class="lp-chat-final__copy">
              <h3></h3>
              <p>
                
              </p>
            </div>

            <div
              class="lp-chat-final__actions"
              data-lp-final-actions
            ></div>
          `;

          final.querySelector(
            'h3'
          ).textContent =
            `Thanks${state.firstName
              ? `, ${state.firstName}`
              : ''
            } we’ve got your enquiry.`;

          const actions =
            final.querySelector(
              '[data-lp-final-actions]'
            );

          if (bookingUrl) {
            const booking =
              document.createElement(
                'a'
              );

            booking.className =
              'lp-chat-final__button lp-chat-final__button--primary';

            booking.href =
              bookingUrl;

            booking.target =
              '_blank';

            booking.rel =
              'noopener noreferrer';

            booking.textContent =
              'Book a free 15-min Call';

            actions.appendChild(
              booking
            );
          } else {
            const bookingDisabled =
              document.createElement(
                'span'
              );

            bookingDisabled.className =
              'lp-chat-final__button lp-chat-final__button--primary is-disabled';

            bookingDisabled.textContent =
              'Book a free 15-min Call';

            bookingDisabled.setAttribute(
              'aria-disabled',
              'true'
            );

            actions.appendChild(
              bookingDisabled
            );
          }

          if (whatsappNumber) {
            const whatsapp =
              document.createElement(
                'a'
              );

            const message =
              `Hi Aman, I just submitted a project enquiry${state.firstName
                ? ` as ${state.firstName}`
                : ''
              }.`;

            whatsapp.className =
              'lp-chat-final__button lp-chat-final__button--secondary';

            whatsapp.href =
              `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
                message
              )}`;

            whatsapp.target =
              '_blank';

            whatsapp.rel =
              'noopener noreferrer';

            whatsapp.textContent =
              'Continue on WhatsApp';

            actions.appendChild(
              whatsapp
            );
          } else {
            const whatsappDisabled =
              document.createElement(
                'span'
              );

            whatsappDisabled.className =
              'lp-chat-final__button lp-chat-final__button--secondary is-disabled';

            whatsappDisabled.textContent =
              'Continue on WhatsApp';

            whatsappDisabled.setAttribute(
              'aria-disabled',
              'true'
            );

            actions.appendChild(
              whatsappDisabled
            );
          }

          conversation.appendChild(
            final
          );

          if (!backendEnabled) {
            console.info(
              '[Liquifyplus Project Assistant] Frontend preview mode: enquiry was not sent to the server.'
            );
          }

          scrollBottom();
        };


      const renderUnsureWhatsAppFinal = (url) => {
        state.completed = true;
        removeOptions();
        closeCountryPicker();
        root.classList.add('is-complete');
        input.value = '';
        input.disabled = true;
        send.disabled = true;
        if (helper) helper.textContent = '';
        back.hidden = true;
        updateProgress();
        playSuccessSound();

        addMessage(
          'assistant',
          'Your WhatsApp number is saved. Opening WhatsApp now…',
          { sound: false }
        );

        const link = document.createElement('a');
        link.className =
          'lp-chat-final__button lp-chat-final__button--primary';
        link.href = url;
        link.textContent = 'Open WhatsApp';
        conversation.appendChild(link);
        scrollBottom();

        try {
          window.location.assign(url);
        } catch (error) {
          setNotice(
            'info',
            'Your enquiry is saved. Use the button to open WhatsApp.'
          );
        }
      };

      const advance =
        async (
          step,
          value,
          label
        ) => {
          if (busy) return;

          busy = true;

          setNotice();

          const previous =
            snapshot();

          state.history.push(
            previous
          );

          removeOptions();

          disableComposer(
            'Loading next question…'
          );

          const serviceBefore =
            effectiveService(previous);

          saveAnswer(
            step,
            value,
            label
          );

          const serviceAfter =
            effectiveService(state);

          try {
            let openingShown =
              false;

            if (
              step.id ===
              'first_name' &&
              state.firstName
            ) {
              await waitForAssistant();

              addMessage(
                'assistant',
                `Nice to meet you, ${state.firstName} 👋`,
                {
                  sound: true
                }
              );

              openingShown = true;
            }

            if (
              (
                step.id === 'service' ||
                (
                  previous.service === 'unsure' &&
                  serviceBefore === 'unsure' &&
                  serviceAfter !== 'unsure'
                )
              ) &&
              serviceOpening(serviceAfter)
            ) {
              await waitForAssistant();

              addMessage(
                'assistant',
                state.unsureWhatsAppRoute
                  ? 'No problem. Share your WhatsApp number and we’ll continue there.'
                  : serviceOpening(serviceAfter),
                {
                  sound: true
                }
              );

              openingShown =
                true;
            }

            if (
              step.id ===
              'phone'
            ) {
              if (state.unsureWhatsAppRoute) {
                if (!whatsappNumber) {
                  throw new Error(
                    'Business WhatsApp is not configured. Please try again later.'
                  );
                }

                if (!backendEnabled) {
                  throw new Error(
                    'Lead saving is unavailable. Please try again later.'
                  );
                }
              }

              if (
                backendEnabled
              ) {
                setNotice(
                  'info',
                  'Saving your enquiry details…'
                );

                await startLead();

                setNotice();
              }
            } else if (
              state.leadId
            ) {
              queueSave();
            }

            const next =
              nextStepId();

            if (
              next ===
              'complete'
            ) {
              await completeLead();

              if (state.unsureWhatsAppRoute) {
                const message =
                  'Hi, I’m not sure which Shopify service I need.';
                const url =
                  `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
                renderUnsureWhatsAppFinal(url);
              } else {
                await renderFinal();
              }
            } else {
              state.current =
                next;

              await renderStep({
                initial:
                  openingShown
              });
            }
          } catch (error) {
            const createdLeadId = state.leadId;
            const createdLeadToken = state.leadToken;

            state.history.pop();

            restoreSnapshot(
              previous
            );

            if (
              step.id === 'phone' &&
              state.unsureWhatsAppRoute &&
              createdLeadId &&
              createdLeadToken
            ) {
              state.leadId = createdLeadId;
              state.leadToken = createdLeadToken;
            }

            renderTranscript();

            setNotice(
              'error',
              error.data?.message ||
              error.message ||
              'We could not save that answer. Please try again.'
            );

            await renderStep({
              initial: true
            });

            if (
              step.id === 'phone' &&
              state.unsureWhatsAppRoute
            ) {
              input.value = value;
              send.disabled = !value.trim();
              setNotice(
                'error',
                error.data?.message ||
                error.message ||
                'We could not save that answer. Please try again.'
              );
            }
          } finally {
            busy = false;

            updateProgress();
          }
        };

      conversation.addEventListener(
        'click',
        (event) => {
          const option =
            event.target.closest(
              '.lp-chat-option'
            );

          if (
            !option ||
            busy
          ) {
            return;
          }

          interacted =
            true;

          unlockAudio();

          const step =
            getStep(
              state.current
            );

          if (!step) return;

          const value =
            option.dataset.value;

          if (
            value ===
            '__skip__'
          ) {
            advance(
              step,
              '',
              step.skipLabel ||
              'Skipped'
            );

            return;
          }

          const match =
            step.options?.find(
              ([optionValue]) =>
                optionValue ===
                value
            );

          advance(
            step,
            value,
            match?.[1] ||
            value
          );
        }
      );

      composer.addEventListener(
        'submit',
        (event) => {
          event.preventDefault();

          if (
            busy ||
            input.disabled
          ) {
            return;
          }

          interacted =
            true;

          unlockAudio();

          const step =
            getStep(
              state.current
            );

          if (!step) return;

          const value =
            input.value.trim();

          const validation =
            validateText(
              step,
              value
            );

          if (validation) {
            setNotice(
              validation.type,
              validation.message
            );

            input.focus();

            return;
          }

          advance(
            step,
            value,
            value
          );
        }
      );

      input.addEventListener(
        'input',
        () => {
          setNotice();

          if (
            state.current ===
            'phone'
          ) {
            const digits =
              input.value.replace(
                /\D/g,
                ''
              );

            if (
              input.value !==
              digits
            ) {
              input.value =
                digits;
            }

            const maxPhoneLengths = {
              IN: 10,
              US: 10,
              CA: 10,
              GB: 10,
              AU: 9,
              AE: 9,
              ZA: 9,
              SG: 8,
              NZ: 10
            };

            const maxLength =
              maxPhoneLengths[state.country] ||
              14;

            input.value =
              input.value.slice(
                0,
                maxLength
              );
          }

          send.disabled =
            input.disabled ||
            !input.value.trim();
        }
      );

      countryOpen?.addEventListener(
        'click',
        openCountryPicker
      );

      countryClose?.addEventListener(
        'click',
        closeCountryPicker
      );

      countrySearch?.addEventListener(
        'input',
        () =>
          renderCountries(
            countrySearch.value
          )
      );

      countryList?.addEventListener(
        'click',
        (event) => {
          const item =
            event.target.closest(
              '.lp-chat-country__item'
            );

          if (!item) return;

          state.country =
            item.dataset.country;

          state.countryName =
            item.dataset.countryName;

          state.callingCode =
            item.dataset.callingCode;

          state.localPhone = '';
          state.phone = '';
          input.value = '';
          send.disabled = true;


          updateCountryUI();

          closeCountryPicker();

          setNotice(
            'info',
            `${state.countryName} ${state.callingCode} selected. Enter your WhatsApp number without the country code.`
          );

          input.focus({
            preventScroll: true
          });
        }
      );

      back.addEventListener(
        'click',
        async () => {
          if (
            busy ||
            !state.history.length ||
            state.completed
          ) {
            return;
          }

          interacted =
            true;

          unlockAudio();

          const previous =
            state.history.pop();

          const remaining =
            state.history;

          restoreSnapshot(
            previous
          );

          state.history =
            remaining;

          renderTranscript();

          await renderStep({
            initial: true
          });

          if (
            state.leadId
          ) {
            queueSave();
          }

          updateProgress();
        }
      );

      soundToggle?.addEventListener(
        'click',
        () => {
          interacted =
            true;

          soundEnabled =
            !soundEnabled;

          try {
            sessionStorage.setItem(
              'lp-qualifier-sound',
              soundEnabled
                ? 'on'
                : 'off'
            );
          } catch (error) { }

          setSoundUI();

          if (
            soundEnabled
          ) {
            unlockAudio();

            playMessageSound();
          }
        }
      );

      const reset =
        (trigger) => {
          state =
            baseState();

          root.classList.remove(
            'is-complete'
          );

          const href =
            trigger
              ?.getAttribute(
                'href'
              ) || '';

          const requested =
            trigger?.dataset
              .service ||
            (
              href.startsWith(
                '#project-qualifier-'
              )
                ? href.replace(
                  '#project-qualifier-',
                  ''
                )
                : ''
            );

          const mapped =
            serviceAliases[
            String(
              requested || ''
            )
              .trim()
              .toLowerCase()
            ];

          if (mapped) {
            state.service =
              mapped;

            state.servicePreset =
              true;
          }

          state.source =
            trigger?.dataset
              .source ||
            location.pathname;

          state.sourceCta =
            trigger?.dataset
              .cta ||
            trigger?.textContent
              ?.trim()
              ?.slice(
                0,
                100
              ) ||
            '';

          state.sourceContext =
            trigger?.dataset
              .context ||
            '';

          conversation.innerHTML =
            '';

          input.value = '';

          closeCountryPicker();

          updateCountryUI();

          setNotice();

          try {
            const stored =
              sessionStorage.getItem(
                'lp-qualifier-sound'
              );

            if (stored) {
              soundEnabled =
                stored ===
                'on';
            } else {
              soundEnabled =
                root.dataset
                  .soundDefault !==
                'off';
            }
          } catch (error) {
            soundEnabled =
              root.dataset
                .soundDefault !==
              'off';
          }

          setSoundUI();

          if (mapped) {
            addMessage(
              'assistant',
              serviceOpening(mapped),
              {
                sound: false
              }
            );
          } else {
            addMessage(
              'assistant',
              'Hi 👋 I’m the Project Assistant. I’ll ask a few quick questions so we can understand your project better.',
              {
                sound: false
              }
            );
          }

          state.current =
            sequence()[0] ||
            'service';

          renderStep({
            initial: true
          });

          updateProgress();
        };

      const openQualifier =
        (trigger) => {
          interacted =
            true;

          /*
            IMPORTANT:
            This runs directly inside the user's CTA click/tap.
            That is what allows Safari/iOS/Chrome to unlock Web Audio.
          */
          unlockAudio();

          reset(trigger);

          root.hidden =
            false;

          document.body
            .classList.add(
              'lp-qualifier-open'
            );

          if (
            typeof dialog
              .showModal ===
            'function'
          ) {
            dialog.showModal();
          } else {
            dialog.setAttribute(
              'open',
              ''
            );
          }

          /*
            Entrance sound is intentionally fired immediately after
            showModal while still inside the original user gesture.
          */
          playEntranceSound();

          close.focus({
            preventScroll: true
          });
        };

      const closeQualifier =
        () => {
          removeOptions();

          closeCountryPicker();

          if (dialog.open) {
            dialog.close();
          } else {
            dialog.removeAttribute(
              'open'
            );
          }

          root.hidden =
            true;

          document.body
            .classList.remove(
              'lp-qualifier-open'
            );
        };

      close.addEventListener(
        'click',
        closeQualifier
      );

      dialog.addEventListener(
        'cancel',
        (event) => {
          event.preventDefault();

          closeQualifier();
        }
      );

      document.addEventListener(
        'click',
        (event) => {
          const trigger =
            event.target.closest(
              '[data-lp-qualifier-open], a[href^="#project-qualifier"]'
            );

          if (!trigger) {
            return;
          }

          event.preventDefault();

          /*
            Unlock audio before any setTimeout.
            Required for reliable iOS Safari sound.
          */
          interacted =
            true;

          unlockAudio();

          const drawer =
            trigger.closest(
              '[data-lp-mobile-drawer], .lp-mobile-drawer, #menu-drawer'
            );

          if (drawer) {
            document
              .querySelectorAll(
                '[data-lp-drawer-close], .menu-drawer__close-button'
              )
              .forEach(
                (button) =>
                  button.click()
              );

            window.setTimeout(
              () =>
                openQualifier(
                  trigger
                ),
              160
            );

            return;
          }

          openQualifier(
            trigger
          );
        }
      );

      document.addEventListener(
        'pointerdown',
        (event) => {
          if (
            countryPicker?.hidden ||
            countryPicker?.contains(
              event.target
            ) ||
            countryOpen?.contains(
              event.target
            )
          ) {
            return;
          }

          closeCountryPicker();
        },
        {
          passive: true
        }
      );

      setSoundUI();
      updateCountryUI();
    }
  );
})();